

const AppConst = {
  API_URL: "http://localhost:8080/",
  TOKEN_KEY: "authtoken"
} 

export default AppConst;